<div [class]="typologies">
  <router-outlet />
</div>
